import script from "./GodApeQuestWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./GodApeQuestWallet.vue?vue&type=script&setup=true&lang=js"

import "./GodApeQuestWallet.vue?vue&type=style&index=0&id=05650ff5&lang=scss"

const __exports__ = script;

export default __exports__